'use strict';
var uncurryThis = require('../internals/function-uncurry-this');

module.exports = uncurryThis([].slice);



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/array-slice.js
// module id = 82
// module chunks = 13